export const SUPER_ADMIN = 1;
export const ADMIN = 2;
export const BRANCH = 3;
export const ADMIN_COMPANY = 4;

export default { SUPER_ADMIN, ADMIN, BRANCH, ADMIN_COMPANY };
